import styled from '@emotion/styled';
import ArrowDown from '../../UI/Icon/ArrowDown';
import { mediaQueries, remCalc, font } from '../../css';

const StyledTitle = styled('button')(({ theme }) => ({
    appearance: 'none',
    display: 'flex',
    margin: 0,
    padding: remCalc(0, 10),
    alignItems: 'center',
    border: 0,
    borderRadius: 0,
    background: 'transparent',
    lineHeight: font.size.l,
    fontFamily: font.family.body,
    fontSize: '1.05rem',
    fontWeight: font.weight.medium,
    color: theme.global.textColor,
    cursor: 'pointer',
    [mediaQueries.medium]: {
        padding: 0,
        cursor: 'default',
    },
    ':focus': {
        outline: 'none',
        backgroundColor: theme.footer.titleBgColor,
    },
}));

const StyledTitleLink = styled('a')(({ theme }) => ({
    padding: remCalc(4, 10),
    marginLeft: remCalc(21),
    verticalAlign: 'middle',
    border: 0,
    borderRadius: 0,
    background: 'transparent',
    lineHeight: font.size.l,
    fontFamily: font.family.body,
    fontSize: '1.05rem',
    fontWeight: font.weight.medium,
    color: theme.global.textColor,
    cursor: 'pointer',
    ':focus': {
        outline: 'none',
        backgroundColor: theme.footer.titleBgColor,
    },
}));

const StyledIcon = styled(ArrowDown)(
    () => ({
        display: 'inline-flex',
        marginRight: remCalc(6),
        transition: 'transform .4s ease',
    }),
    ({ isExpanded }) => {
        return isExpanded ? { transform: 'rotateX(180deg)' } : {};
    },
);

const StyledList = styled('ul')(
    () => ({
        margin: remCalc(0, 0, 5, 20),
        padding: 0,
        maxHeight: 0,
        overflow: 'hidden',
        opacity: 0,
        listStyle: 'none',
        lineHeight: 1.6,
        transition: 'opacity .3s ease, max-height .3s ease',
    }),
    ({ isExpanded }) => {
        return isExpanded
            ? {
                  display: 'block',
                  maxHeight: remCalc(200),
                  opacity: 1,
              }
            : {};
    },
);

const StyledItem = styled('li')(() => ({
    display: 'block',
}));

const StyledLink = styled('a')(({ theme }) => ({
    borderBottomColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: remCalc(1),
    lineHeight: '1.1rem',
    fontSize: '1.1rem',
    fontWeight: font.weight.thin,
    textDecoration: 'none',
    opacity: 0.7,
    color: theme.global.textColor,
    ':hover,:focus': {
        opacity: 1,
        color: theme.global.textColor,
    },
    ':focus': {
        borderBottomColor: theme.global.textColor,
    },
}));

export { StyledIcon, StyledItem, StyledLink, StyledList, StyledTitle, StyledTitleLink };
